(() => {
  const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

  function bind(card) {
    const rect = () => card.getBoundingClientRect();

    const move = (e) => {
      const r = rect();
      const x = (e.clientX - r.left) / r.width;
      const y = (e.clientY - r.top) / r.height;

      card.style.setProperty("--mx", (x * 100).toFixed(2) + "%");
      card.style.setProperty("--my", (y * 100).toFixed(2) + "%");

      const ry = clamp((x - 0.5) * 18, -12, 12);
      const rx = clamp((0.5 - y) * 18, -12, 12);

      card.style.setProperty("--ry", ry.toFixed(2) + "deg");
      card.style.setProperty("--rx", rx.toFixed(2) + "deg");

      card.classList.add("is-active");
    };

    const leave = () => {
      card.classList.remove("is-active");
      card.style.setProperty("--mx", "50%");
      card.style.setProperty("--my", "50%");
      card.style.setProperty("--ry", "0deg");
      card.style.setProperty("--rx", "0deg");
    };

    card.addEventListener("pointermove", move);
    card.addEventListener("pointerleave", leave);
  }

  function init() {
    document.querySelectorAll(".holo-card").forEach(bind);
  }

  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", init)
    : init();
})();
